import "../styles.css";

export default function About() {
	return (
		<section className="about">
			<div className="set-right">
				<h2 className="h1 uppercase">Dive Club</h2>
				<h2 className="h1 ">
					<span>Explore</span> the world!
				</h2>
				<hr className="hr hr-dive-gallery" />
			</div>
			<p>
				Rabbitfish heelsplitter at flounder search clownfish.
				Butterflyfish motionless Manta ray, crazy snowcrab swimming at,
				catshark soldierfish threadfin. Colorful blue tang houndshark,
				swim at banded grunt in, net a king crab. Butterflyfish
				motionless Manta ray, crazy snowcrab swimming at, catshark
				soldierfish threadfin. Coral hogfish snake eel goatfish and
				Black clown goby fanatic jumping at a nurse shark. Mandarinfish
				in a fire fish, an algae unknown. Myster.
			</p>
			<p>
				Snail lionfish papershell houndshark. Hippo tang gold damsel
				peaclam, swam at Mandarinfish, puffer fish is sea grape.
				Bonnethead at puffer fish pipefish octopus threadfin. Hippo tang
				pebblesnail fins raced. Banana wrasse gold damsel stingray black
				clown goby an puffer fish applesnail octopus clownfish,
				bannerfish milk shark soldierfish. Sea coral wobbegong shark,
				Milk shark non Spotted sweetlips a, Butter hamlet bonnethead
				elktoe. Wobbegong shark blue whale gol.
			</p>
		</section>
	);
}
